import { Api } from "../axios-config";
import { SinisterDocumentType } from "./types";
import { SinisterValuesDocumentType } from "./types/sinister-values-document.type";

interface IAuth {
	accessToken: string;
}
export type TSinisterDocumentsListaAndTotal = {
	results: SinisterDocumentType[];
	totalCount: number;
};

const uploadSinisterDocument = async (sinisterId: string, checkListId: string, documentTypeId: string, file: File): Promise<any> => {
	const formData = new FormData();
	formData.append("sinisterId", sinisterId);
	formData.append("checkListId", checkListId);
	formData.append("file", file);
	const { data } = await Api().post("/sinister-document", formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

	return data as any;
};

const uploadSinisterValuesDocument = async (sinisterId: string, checkListId: string, documentTypeId: string, file: File): Promise<any> => {
	const formData = new FormData();
	formData.append("sinisterId", sinisterId);
	formData.append("sinisterValuesId", checkListId);

	formData.append("file", file);
	const { data } = await Api().post("/sinister-values-document", formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

	return data as any;
};

const getSinisterDocuments = async (sinisterId: string, checkListId: string) => {
	const data = await Api().get(`/sinister-document/search/${sinisterId}/${checkListId}`);

	return data;
};

const getSinisterValuesDocumentTypes = async (sinisterParam: string, listId: string): Promise<SinisterValuesDocumentType[]> => {
	const { data } = await Api().get(`/sinister-values-document/${sinisterParam}/lista/${listId}`);
	return data as SinisterValuesDocumentType[];
};

const removeDocumentBySinister = async (documentId: string): Promise<void | Error> => {
	try {
		const { data } = await Api().patch(`/sinister-document/sinister/${documentId}`);

		if (!data) return new Promise((_, reject) => reject(new Error("Erro ao remover documento.")));
	} catch (error: any) {
		console.error(error);
		return new Promise((_, reject) => reject(error));
	}
};

const previewDocumentBySinisterValues = async (documentId: string): Promise<Blob | Error> => {
	try {
		const { data } = await Api().get(`/sinister-values-document/buffer/${documentId}`, {
			responseType: "blob",
		});
		return data;
	} catch (error: any) {
		return new Error(error?.message || "Erro ao carregar o documento");
	}
};

const previewDocumentBySinister = async (documentId: string): Promise<Blob | Error> => {
	try {
		const { data } = await Api().get(`/sinister-document/buffer/${documentId}`, {
			responseType: "blob",
		});
		return data;
	} catch (error: any) {
		return new Error(error?.message || "Erro ao carregar o documento");
	}
};

export const SinisterDocumentsService = {
	uploadSinisterDocument,
	getSinisterDocuments,
	getSinisterValuesDocumentTypes,
	uploadSinisterValuesDocument,
	removeDocumentBySinister,
	previewDocumentBySinisterValues,
	previewDocumentBySinister,
};
